import { WidgetView } from 'common';

export type SourceType = 'collection' | 'product';

export function getSourceType(widget: WidgetView): SourceType {
  const hasProductList = Array.isArray(widget.settings.default_sources?.product_list);
  const hasCollectionList = Array.isArray(widget.settings.default_sources?.collection_list);

  // If there is a product list, it's a product widget (even if there is also a collection list)
  if (hasProductList) {
    return 'product';
  }

  if (hasCollectionList) {
    return 'collection';
  }

  // Fallback to collection when sources are missing to keep UI stable.
  console.warn('Widget missing source lists; defaulting to collection.', {
    widgetId: widget._id,
    widgetName: widget.name,
  });
  return 'collection';
}
